module.exports = __webpack_public_path__ + "img/calque-phone.ccea0216.png";